export const slugify = (text: string): string => {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w-]+/g, "") // Remove all non-word chars
      .replace(/--+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  };

/**
 * Checks if an email matches any pattern in the allowed patterns array.
 * Supports both exact string matches and regex patterns.
 * 
 * @param email - The email address to check
 * @param allowedPatterns - Array of allowed patterns (exact strings or regex patterns)
 * @returns true if the email matches any pattern, false otherwise
 * 
 * @example
 * // Exact match
 * matchesObserverPattern('yogesh@asynclabs.ai', ['yogesh@asynclabs.ai']) // true
 * 
 * @example
 * // Regex pattern
 * matchesObserverPattern('yogesh.test@asynclabs.ai', ['yogesh.*@asynclabs.ai']) // true
 */
export const matchesObserverPattern = (email: string | undefined | null, allowedPatterns: string[]): boolean => {
  if (!email || !allowedPatterns || allowedPatterns.length === 0) {
    return false;
  }

  return allowedPatterns.some((pattern) => {
    // Check for exact match first
    if (pattern === email) {
      return true;
    }

    // Try to match as regex pattern
    try {
      // Check if pattern contains regex special characters
      const hasRegexChars = /[.*+?^${}()|[\]\\]/.test(pattern);
      
      if (hasRegexChars) {
        // Create regex from pattern (anchor to start and end for security)
        const regex = new RegExp(`^${pattern}$`, 'i');
        return regex.test(email);
      }
      
      return false;
    } catch (error) {
      // If regex is invalid, fall back to exact match
      return pattern === email;
    }
  });
};